import { render, staticRenderFns } from "./transition-expand.vue?vue&type=template&id=f04e6772&scoped=true"
import script from "./transition-expand.vue?vue&type=script&lang=js"
export * from "./transition-expand.vue?vue&type=script&lang=js"
import style0 from "./transition-expand.vue?vue&type=style&index=0&id=f04e6772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04e6772",
  null
  
)

export default component.exports